module.exports = __webpack_public_path__ + "img/tabela_vazia.f35ff2b9.svg";